module.exports = __webpack_public_path__ + "static/media/clock.4eb1b734.svg";